export const addDate = (originalDate: Date, y = 0, m = 0, d = 0): Date => {
  const newDate = new Date(originalDate);
  newDate.setFullYear(newDate.getFullYear() + y);
  newDate.setMonth(newDate.getMonth() + m);
  newDate.setDate(newDate.getDate() + d);
  return newDate;
};
